import { render } from "./Alerts.vue?vue&type=template&id=437c2285&scoped=true&ts=true"
import script from "./Alerts.vue?vue&type=script&lang=ts"
export * from "./Alerts.vue?vue&type=script&lang=ts"

import "./Alerts.vue?vue&type=style&index=0&id=437c2285&scoped=true&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\atlanta-fe-git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-437c2285"]])

export default __exports__